<div class="container">
  <div class="row">
    <div class="col-12">
      <stumpy-caption></stumpy-caption>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <ul class="list-inline">
        <li class="list-inline-item"><stumpy-world [worldId]="0"></stumpy-world></li>
        <li class="list-inline-item"><stumpy-world [worldId]="1"></stumpy-world></li>
      </ul>
    </div>
  </div>
</div>
